/**
 * customer-portal feature の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 * - import 先も Edge 互換である必要がある（型のみ依存に留めるか、純定数のみ）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const CUSTOMER_PORTAL_PUBLIC_PATHS = {
  pages: ['/customer-portal'] as const,
  /**
   * 認証不要の API エンドポイント。
   */
  apis: [
    // 🔴 2026-08-28（Task 9）: `/api/customer-portal/session`（GET）は契約内容確認ポータルと
    //    一緒に削除した。ここは前方一致（`p` または `p + '/'`）なので、親を残すと
    //    消えたルートの名前空間ごと公開したままになる。**残っている子だけ**を挙げる。
    //    `session/track` はマイページ本体が閲覧記録に使っており現役
    //    （`frontend/pages/mypage/hooks/use-mypage-data.ts:69`）。
    '/api/customer-portal/session/track',
    // '/api/customer-portal/verify' は Issue #5058 Phase C で削除済 (Q-1/Q-8 確定で SMS verify 経路廃止)
    '/api/customer-portal/track-section',
    '/api/customer-portal/error-log',
    '/api/customer-portal/fund-plan',
    '/api/customer-portal/schedule',
    '/api/customer-portal/payment-schedule',
    '/api/customer-portal/loan',
    '/api/customer-portal/events',
    // '/api/customer-portal/documents' は 2026-08-28（Task 9）で契約内容確認ポータルと一緒に削除
    '/api/customer-portal/notifications',
    '/api/customer-portal/g-plans',
    // PR4: お客様認証 API（スタッフ認証不要。各ルートで customer_session / reset token を検証）
    '/api/customer/auth',
  ] as const,
} as const
